"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SignupFlowToPath = exports.SignupFlows = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _SignupFlowToPath;

var SignupFlows = {
  CRM: 'CRM',
  FB_CRM: 'FB_CRM',
  MARKETING: 'MARKETING',
  SALES: 'SALES',
  ACADEMY: 'ACADEMY',
  CLASSROOM_TRAINING: 'CLASSROOM_TRAINING',
  CONTENT: 'CONTENT',
  HUBSPOT_FOR_STARTUPS: 'HUBSPOT_FOR_STARTUPS',
  INTEGRATIONS: 'INTEGRATIONS',
  PURCHASE: 'PURCHASE',
  SERVICE: 'SERVICE',
  WORDPRESS: 'WORDPRESS',
  WORDPRESS_LOGIN: 'WORDPRESS_LOGIN',
  GROWTH_HUB: 'GROWTH_HUB',
  DEVELOPERS: 'DEVELOPERS',
  EMBEDDED: 'EMBEDDED',
  CONTENT_HUB: 'CONTENT_HUB',
  STANDALONE_CMS_PARTNER: 'STANDALONE_CMS_PARTNER'
};
exports.SignupFlows = SignupFlows;
var SignupFlowToPath = (_SignupFlowToPath = {}, (0, _defineProperty2.default)(_SignupFlowToPath, SignupFlows.CRM, 'crm'), (0, _defineProperty2.default)(_SignupFlowToPath, SignupFlows.FB_CRM, 'fb-crm'), (0, _defineProperty2.default)(_SignupFlowToPath, SignupFlows.MARKETING, 'marketing'), (0, _defineProperty2.default)(_SignupFlowToPath, SignupFlows.SALES, 'sales'), (0, _defineProperty2.default)(_SignupFlowToPath, SignupFlows.ACADEMY, 'academy'), (0, _defineProperty2.default)(_SignupFlowToPath, SignupFlows.CLASSROOM_TRAINING, 'classroom-training'), (0, _defineProperty2.default)(_SignupFlowToPath, SignupFlows.CONTENT, 'content'), (0, _defineProperty2.default)(_SignupFlowToPath, SignupFlows.HUBSPOT_FOR_STARTUPS, 'hubspot-for-startups'), (0, _defineProperty2.default)(_SignupFlowToPath, SignupFlows.INTEGRATIONS, 'integrations'), (0, _defineProperty2.default)(_SignupFlowToPath, SignupFlows.PURCHASE, 'purchase'), (0, _defineProperty2.default)(_SignupFlowToPath, SignupFlows.SERVICE, 'service'), (0, _defineProperty2.default)(_SignupFlowToPath, SignupFlows.WORDPRESS, 'wordpress'), (0, _defineProperty2.default)(_SignupFlowToPath, SignupFlows.WORDPRESS_LOGIN, 'wordpress-login'), (0, _defineProperty2.default)(_SignupFlowToPath, SignupFlows.GROWTH_HUB, 'growth-hub'), (0, _defineProperty2.default)(_SignupFlowToPath, SignupFlows.DEVELOPERS, 'developers'), (0, _defineProperty2.default)(_SignupFlowToPath, SignupFlows.EMBEDDED, 'embedded'), (0, _defineProperty2.default)(_SignupFlowToPath, SignupFlows.CONTENT_HUB, 'content-hub'), (0, _defineProperty2.default)(_SignupFlowToPath, SignupFlows.STANDALONE_CMS_PARTNER, 'standalone-cms-partner'), _SignupFlowToPath);
exports.SignupFlowToPath = SignupFlowToPath;